import React, { useState } from 'react';
import { EmptyPage } from '../EmptyPage';
import { Link, Route, Routes } from 'react-router-dom';
import { RoutePage } from './Route';
import { Select } from '../../components/Select';
import { getStorageData } from '../../helpers';
import { ADVERT_CITY_STORAGE_NAME, createHandlerWithStorage } from '../../helpers/localStorage';
import { SearchSelect } from '../../components/SearchSelect';


function getProgressData(promoter, isCurrentRoute, routeId) {
    const {isFullReport} = promoter;
    const {progress} = isCurrentRoute ? promoter.currentRoute : promoter.routeQueue.find(r => r._id === routeId);

    let successPorchCount = null;
    let successMailboxCount = null
    let spentMailboxCount = null

    if (isFullReport) {
        successPorchCount = progress.reduce((total, cur) => total + cur.donePorches.filter(pInfo => pInfo.photoUrls.length >= 2 && pInfo.videoUrl.name && !pInfo.rejectComment).length, 0)
        successMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorches.filter(pInfo => pInfo.photoUrls.length >= 2 && pInfo.videoUrl.name && !pInfo.rejectComment).length/cur.porchCount)), 0)
        spentMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorches.filter(pInfo => pInfo.photoUrls.length || pInfo.videoUrl.name).length/cur.porchCount)), 0)
    } else {
        successPorchCount = progress.reduce((total, cur) => total + cur.donePorchUrls.filter(p => !p.rejectComment).length, 0)
        successMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorchUrls.filter(p => !p.rejectComment).length/cur.porchCount)), 0)
        spentMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorchUrls.length/cur.porchCount)), 0)
    }

    return {successPorchCount, successMailboxCount}
}

const RouteItem = ({data, promoter, isCurrentRoute}) => {
    try {
    const {id, porchCount, mailboxCount} = data;
    const thisRoute = isCurrentRoute ? promoter.currentRoute : promoter.routeQueue.find(r => r._id === data._id);
    const {started} = thisRoute;
    
    const {successPorchCount, successMailboxCount} = getProgressData(promoter, isCurrentRoute, data._id);
    const progressPercent = Math.round((successMailboxCount/mailboxCount)*100);

    return (
        <Link to={data._id} className="routes__item route-item dark-theme-bg0-hover-bg1">
            <div className="route-item__header">
                <h3>Маршрут #{id} ({isCurrentRoute ? started ? 'в работе':'назначен' : 'В очереди'})</h3>
                <h4>{promoter.fullname}</h4>
            </div>
            <div className="route-item__body">
                <div className="route-item__row">
                    <div className="route-item__col">Подъездов: {successPorchCount}/{porchCount}</div>
                    <div className="route-item__col">Ящиков: {successMailboxCount}/{mailboxCount}</div>
                </div>
                <div className="route-item__row">
                    <div className="route-item__col">Ставка: {thisRoute.bet} руб/ящик</div>
                    {thisRoute.readyToCheck &&<div className="route-item__col" style={{color: 'green'}}>Готов к проверке</div>}
                </div>
                <div className="route-item__row">
                    <div className="route-item__col full">Листовки: {thisRoute.flyers.map(f => f.name).join(', ')}</div>
                </div>
            </div>
            <div className="route-item__footer">
                <div className="route-item__progress-scale progress-scale">
                    <div className='progress-scale__scale dark-theme-bg1' style={{width: `${progressPercent}%`}}></div>
                    <div className='progress-scale__percent'>{progressPercent}%</div>
                </div>
            </div>
        </Link>
    )
    } catch(e) {
        console.log('ERROR', e, promoter, data)
    }
}

export const RoutesPage = ({list, promoters, cities}) => {

    const activeRoutes = list.filter(r => r.promoter).map(r => {
        const thisProm = promoters.find(p => p._id === r.promoter._id);
        return {
            ...r,
            isCurrentRoute: thisProm.currentRoute._id === r._id
        }
    });

    const [city, setCity] = useState(getStorageData(cities, ADVERT_CITY_STORAGE_NAME));
    const setCityHandler = createHandlerWithStorage(setCity, ADVERT_CITY_STORAGE_NAME);

    const thisCityPromoters = [{_id: 'null', fullname: 'Все промоутеры'}, ...promoters.filter(p => p.city._id === city)];
    const [selectedProm, selectProm] = useState(thisCityPromoters[0]._id);
    if (!activeRoutes.length) {
        return <EmptyPage message='Нет активных маршрутов' />
    }
    const thisCityRoutes = activeRoutes.filter(r => r.city._id === city);
    const filteredRoutes = thisCityRoutes.filter(r => selectedProm === 'null' ? true : r.promoter._id === selectedProm)

    const RouteList = () => {
        return (
            <>
                <div className="routes__header" style={{display: 'flex', columnGap: '16px'}}>
                    <Select enums={cities} value={city} changeHandler={(e) => setCityHandler(e.target.value)} />
                    <SearchSelect
                        options={thisCityPromoters.map(e => ({value: e._id, label: e.fullname}))}
                        value={selectedProm}
                        changeHandler={(e) => selectProm(e.value)}
                    />
                </div>
                <div className="routes__list">
                    {filteredRoutes.map(r => <RouteItem key={r._id} data={r} isCurrentRoute={r.isCurrentRoute} promoter={promoters.find(p => p._id === r.promoter._id)} />)}
                </div>
            </>
        )
    }
    return (
        <div className="routes">
            <div className="container">
                <Routes>
                    <Route path="/" element={<RouteList />} />
                    <Route path=":id" element={<RoutePage />} />
                    <Route path="*" element={<EmptyPage message="Страница не найдена" />} />
                </Routes>
            </div>
        </div>
    );
};
